import { useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";

const ProductCard = ({ product, index = 0, visible = true, onAddToCart }) => {
  const navigate = useNavigate();

  const handleAddToCart = (e) => {
    e.stopPropagation(); // prevent navigation
    if (onAddToCart) onAddToCart(product);
  };

  return (
    <div
      onClick={() => {
        navigate(`/products/${product?._id}`);
        window.scrollTo({ top: "0", behavior: "smooth" });
      }}
      className="cursor-pointer group transition-all duration-500 relative"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(40px)",
        transitionDelay: `${index * 80}ms`,
      }}
    >
      {/* Image container */}
      <div
        className="relative rounded-xl overflow-hidden"
        style={{ height: "250px" }}
      >
        <img
          src={product.coverImage || product.images?.[0]}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />

        {/* Hover overlay */}
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{
            background:
              "linear-gradient(160deg, rgba(192,32,208,0.18), rgba(100,0,120,0.3))",
          }}
        />

        {/* Top accent line */}
        <div
          className="absolute top-0 left-0 right-0 h-0.5 scale-x-0 opacity-0 group-hover:scale-x-100 group-hover:opacity-100 transition-all duration-300"
          style={{
            background: "#e040fb",
            transformOrigin: "left",
          }}
        />

        {/* Add to Cart button - appears on hover */}
        <button
          onClick={handleAddToCart}
          className="
    absolute bottom-3 right-3
    p-2.5 rounded-md
    bg-white shadow-lg
    transition-all duration-300
    hover:bg-[#041122]
    hover:scale-110
    active:scale-95
    group/cart
  "
          aria-label="Add to cart"
        >
          <ShoppingCart
            size={18}
            className="text-btnColor transition-colors duration-300 group-hover/cart:text-white"
          />
        </button>
      </div>

      {/* TEXT */}
      <div className="text-center mt-3 px-2 overflow-hidden">
        <p className="text-[#041122] font-bold text-sm sm:text-base lg:text-lg tracking-wide">
          {product.name}
        </p>
        <p className="text-gray-500 text-xs md:text-sm mt-1 leading-tight line-clamp-1">
          {product.tagline}
        </p>
      </div>
    </div>
  );
};
export const ProductSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div className="rounded-xl bg-gray-200" style={{ height: "250px" }} />

      <div className="text-center mt-3 px-2 space-y-2">
        <div className="h-3 bg-gray-200 rounded w-1/2 mx-auto" />
        <div className="h-3 bg-gray-200 rounded w-3/4 mx-auto" />
      </div>
    </div>
  );
};

export default ProductCard;
